// services/productService.js
import axios from "axios";
import config from "../config/config";
import { handleApiError } from "../utils/errorHandler";

const BASE_URL = `${config.apiUrl}/api/food`;

export const productService = {
  addProduct: async (formData) => {
    console.log("add Product ", formData);
    try {
      const response = await axios.post(`${BASE_URL}/add`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  updateProduct: async (id, formData) => {
    try {
      const response = await axios.put(`${BASE_URL}/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  getProduct: async (id) => {
    try {
      const response = await axios.get(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
};
